import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'src/app/store/appState.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-premium-modal',
  templateUrl: './premium-modal.component.html',
  styleUrls: ['./premium-modal.component.scss']
})
export class PremiumModalComponent implements OnInit {

  @Input() campaignTitle: string;

  bookMeeting: string;
  constructor(private modalService : NgbModal) { 

  }

  ngOnInit(): void {
    this.bookMeeting = environment.links.bookMeetingLP;
  }

  onClickDismissModal(){
    this.modalService.dismissAll()
  }

}
